import React, { useState, useEffect } from 'react';
import './MusicLab.css';

// Import images for Music Lab
import musicLab1 from '../assets/music (2).webp';
import musicLab2 from '../assets/music (1).webp';
import musicLab3 from '../assets/music (4).webp';
import musicLab4 from '../assets/music (3).webp';

const MusicLab = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const musicImages = [musicLab1, musicLab2, musicLab3, musicLab4];

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-slide images every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === musicImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? musicImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === musicImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="musiclab-container">
       {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>MUSIC LBA</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Music Lab</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="musiclab-main-content">
        <div className="musiclab-content-wrapper">
          {/* Left Side - Text Content */}
          <div className={`musiclab-text-content ${isVisible ? 'musiclab-visible' : ''}`}>
            <h2 className="musiclab-main-heading">MUSIC LAB</h2>
            
            <p className="musiclab-intro-text">
              Art enriches all of our lives! Here at The Music Lab we provide a nurturing environment 
              for children to engage in the finest performing arts education.
            </p>

            <p className="musiclab-section-text">
              Our staff is composed of experienced educators and professional performers, who provide 
              our students with the very best in technical training and performance opportunities. Most 
              of our teachers are well trained in Carnatic music and Hindustani music.
            </p>

            <p className="musiclab-section-text">
              The Music lab transforms lives through excellence in music teaching, performance, creative 
              activities, research and service.
            </p>

            <p className="musiclab-section-text">
              The aim of having a music lab in school is to promote the study, practice and knowledge of 
              music in our students and to give or arrange concerts and musical entertainments.
            </p>

            <p className="musiclab-section-text">
              The lab has all kinds of instrument like drums, keyboard, veenas, mridangam, table, dholak, 
              dappu, Kanjari, kango, guitar, digital tanpura. The lab also has a music library which 
              contains wide range music related books. Collections also include non-print materials, such 
              as digitized music scores or audio recordings etc.
            </p>
          </div>

          {/* Right Side - Image Slider */}
          <div className={`musiclab-image-slider ${isVisible ? 'musiclab-visible' : ''}`}>
            <div className="musiclab-slider-container">
              {musicImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Music Lab ${index + 1}`}
                  className={`musiclab-slider-image ${
                    index === currentImageIndex ? 'musiclab-active' : ''
                  }`}
                />
              ))}
              
              {/* Navigation Arrows */}
              <button 
                className="musiclab-slider-arrow musiclab-arrow-left"
                onClick={handlePrevImage}
              >
                ‹
              </button>
              <button 
                className="musiclab-slider-arrow musiclab-arrow-right"
                onClick={handleNextImage}
              >
                ›
              </button>
              
              {/* Slider Dots */}
              <div className="musiclab-slider-dots">
                {musicImages.map((_, index) => (
                  <span
                    key={index}
                    className={`musiclab-dot ${
                      index === currentImageIndex ? 'musiclab-dot-active' : ''
                    }`}
                    onClick={() => handleDotClick(index)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicLab;